import { IAccount } from './account.models';

// ─── Smart Inbox feature-level UI models ─────────────────────────────────────

export enum ISmartInboxState {
    INITIAL = 'initial', // Waiting for the inbox list to be loaded
    CONNECT = 'connect', // When no accounts are found, show the welcome/connect component
    CONNECTING = 'connecting', // NOT USED
    CONNECTED = 'connected', // When accounts are found, show the inbox view component
    CONNECTION_ERROR = 'connection_error', // When an error occurs
    SERVICE_ERROR = 'service_error', // When the server is down
}

export type ISmartInboxStateType = typeof ISmartInboxState[keyof typeof ISmartInboxState];

export const InboxFolderType = {
    ALL: 'all',
    DRAFTS: 'drafts',
    SENT: 'sent',
    MENTIONS: 'mentions',
    TASKS: 'tasks',
    ARCHIVED: 'archived'
} as const;

export type InboxFolderType = (typeof InboxFolderType)[keyof typeof InboxFolderType];
export interface IInboxFolder {
    type: InboxFolderType;
    icon: string;
    label: string;
    total: number;
    unread_count: number;
}

export interface IFolderKPI {
    id: InboxFolderType;
    name: string;
    total: number;
    unread: number;
}

// ─────────────────────────────────────────────────────────────────────────────
// Recipient-mailbox tag preference
// ─────────────────────────────────────────────────────────────────────────────
// Where the user wants the recipient-mailbox tag to appear. Set in
// Settings → Smart Inbox; see `MailboxTagPreferenceService`.

export const MailboxTagDisplay = {
    /** Never show the tag, however many mailboxes are connected. */
    HIDDEN: 'hidden',
    /** Conversation lists only. */
    LIST: 'list',
    /** Conversation lists and the open conversation's header. */
    BOTH: 'both',
} as const;
export type MailboxTagDisplay = (typeof MailboxTagDisplay)[keyof typeof MailboxTagDisplay];

/** Both surfaces by default: the tag is already self-hiding on a single mailbox. */
export const DEFAULT_MAILBOX_TAG_DISPLAY: MailboxTagDisplay = MailboxTagDisplay.BOTH;

export const MAILBOX_TAG_DISPLAY_OPTIONS: MailboxTagDisplay[] = [
    MailboxTagDisplay.HIDDEN,
    MailboxTagDisplay.LIST,
    MailboxTagDisplay.BOTH,
];

export const InboxConfirmationActionType = {
    SHARE_ACCOUNT: 'share_account',
    UNSHARE_ACCOUNT: 'unshare_account',
    SHARE_PERSONAL_CONVERSATION: 'share_personal_conversation',
    DELETE: 'delete',
    DELETE_COMMENT: 'delete_comment',
    DELETE_SIGNATURE: 'delete_signature',
    DISCONNECT: 'disconnect'
}
export type InboxConfirmationActionType = keyof typeof InboxConfirmationActionType;
